// extracted by mini-css-extract-plugin
export default {"hint":"Feedback_hint__6d81V","error":"Feedback_error__pWMEx"};